import React from 'react';
import PropTypes from 'prop-types';
var SvgContextMixin = require('./svgContextMixin');

var DEFAULT_GRID_STEP = 10;

var SvgChartPercentAxis = React.createClass({
  mixins: [SvgContextMixin],

  statics: {
    id: "PercentYAxis",
    defaultGridStep: DEFAULT_GRID_STEP,
    getAxisLength(){
      return 100;
    }
  },

  propTypes: {
    gridStep: PropTypes.number,
    labelWidth: PropTypes.number
  },

  getDefaultProps(){
    return {
      gridStep: DEFAULT_GRID_STEP
    }
  },

  render(){
    return (
      <g id={SvgChartYearGroupAxis.id}>
        {this._getGrid()}
      </g>
    );
  },

  _getGrid(){
    var {box, labelWidth, gridStep} = this.props;

    for (var i = 100; i > 0; i -= gridStep);

    return null;
  }

});


module.exports = SvgChartPercentAxis;
